import { DocumentModel } from '@types';
import { HqApiService } from './hqApiService';

export class DocumentModelsService {
  constructor(private readonly hqApiService: HqApiService) {}

  public async getDocumentModels(): Promise<DocumentModel> {
    const response = await this.hqApiService.get<DocumentModel>({
      path: 'document-models',
    });
    return response;
  }
}
